import * as z from "zod";
//#region src/models/sortParamModel.ts
/**
* Override `sort_by` with actual values from targeted entity.
* eg. `z.enum(caseTemplateSortables).default("name")`
*/
const sortParamModelAsc = z.object({
	sort_by: z.string().optional(),
	sort_dir: z.enum(["asc", "desc"]).default("asc")
});
/**
* Override `sort_by` with actual values from targeted entity.
* eg. `z.enum(caseTemplateSortables).default("name")`
*/
const sortParamModelDesc = z.object({
	sort_by: z.string().optional(),
	sort_dir: z.enum(["asc", "desc"]).default("desc")
});
const getSortParamModel = ({ sortables, default_sort_dir, default_sort_by }) => {
	const keys = sortables.map((s) => `${s.table}.${s.column}`);
	return z.object({
		sort_by: z.enum(keys).optional().refine((v) => v ?? default_sort_by),
		sort_dir: z.enum(["asc", "desc"]).optional().refine((v) => v ?? default_sort_dir)
	});
};
//#endregion
export { getSortParamModel, sortParamModelAsc, sortParamModelDesc };
